import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { DashboardLayout } from "@/components/layout/DashboardLayout";
import LoginPage from "@/pages/LoginPage";
import ForgotPasswordPage from "@/pages/ForgotPasswordPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import ChangePasswordPage from "@/pages/ChangePasswordPage";
import DashboardPage from "@/pages/DashboardPage";
import ProductsListPage from "@/pages/ProductsListPage";
import ProductDetailPage from "@/pages/ProductDetailPage";
import ArchivedProductsPage from "@/pages/ArchivedProductsPage";
import ArchivedCratesPage from "@/pages/ArchivedCratesPage";
import CratesListPage from "@/pages/CratesListPage";
import CrateDetailPage from "@/pages/CrateDetailPage";
import ShipmentsListPage from "@/pages/ShipmentsListPage";
import ShipmentDetailPage from "@/pages/ShipmentDetailPage";
import TicketsListPage from "@/pages/TicketsListPage";
import ClientsListPage from "@/pages/ClientsListPage";
import ClientDetailPage from "@/pages/ClientDetailPage";
import ReportsPage from "@/pages/ReportsPage";
import SettingsPage from "@/pages/SettingsPage";
import SticksPage from "@/pages/SticksPage";
import ClientTeamPage from "@/pages/ClientTeamPage";

function RootRedirect() {
  const { user, loading } = useAuth();
  if (loading) return null;
  return <Navigate to={user ? "/dashboard" : "/login"} replace />;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<RootRedirect />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/change-password" element={<ChangePasswordPage />} />
            <Route element={<DashboardLayout />}>
              <Route path="/dashboard" element={<DashboardPage />} />
              <Route path="/products" element={<ProductsListPage />} />
              <Route path="/products/:id" element={<ProductDetailPage />} />
              <Route path="/crates" element={<CratesListPage />} />
              <Route path="/crates/:id" element={<CrateDetailPage />} />
              <Route path="/shipments" element={<ShipmentsListPage />} />
              <Route path="/shipments/:id" element={<ShipmentDetailPage />} />
              <Route path="/tickets" element={<TicketsListPage />} />
              <Route path="/sticks" element={<SticksPage />} />
              <Route path="/team" element={<ClientTeamPage />} />
              <Route path="/reports" element={<ReportsPage />} />
            </Route>
            <Route element={<DashboardLayout adminOnly={true} />}>
              <Route path="/products/archived" element={<ArchivedProductsPage />} />
              <Route path="/crates/archived" element={<ArchivedCratesPage />} />
              <Route path="/clients" element={<ClientsListPage />} />
              <Route path="/clients/:id" element={<ClientDetailPage />} />
              <Route path="/settings" element={<SettingsPage />} />
            </Route>
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
